import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M22 4H2.01L2 20h20V4zm-2 14H4v-6h16v6zm0-10H4V6h16v2z"
}), 'CreditCardSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/CreditCardSharp.js
// module id = 2981
// module chunks = 2